import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Bascule le manifeste PWA (et le titre iOS) selon l'espace : formateur ou administration.
export const usePwaManifest = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const role = localStorage.getItem('userRole');
    const formateur = role === 'formateur' || pathname.startsWith('/portail-formateur');
    const href = formateur ? '/manifest-formateur.json' : '/manifest.json';
    const title = formateur ? 'OF Manager Formateur' : 'OF Manager Admin';
    const link = document.querySelector('link[rel="manifest"]');
    if (link && link.getAttribute('href') !== href) link.setAttribute('href', href);
    const meta = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    if (meta && meta.getAttribute('content') !== title) meta.setAttribute('content', title);
  }, [pathname]);
};
